export default "__VITE_ASSET__62a402de__"